import React, { useState, useEffect } from 'react';
import { Button, Col } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import '../../../disenio/profiles/orderlist.css';
import { ListOrderingItem } from '../../../../components/lists/ListOrderingItem';
import { ListOrderingItemProfile } from './ListOrderingItemProfile';

export const ModalOrderAnalyte = (props) => {
    const {
        method,
        visibleOrder,
        setVisibleOrder,
        saveOrderProfiles,
        profileOrder,
        profilesId,
        setProfileOrder
    } = props;

    const headerTittle = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Ordenar Perfil</span>
        </div>
    );

    const footerContent = (
        <div>
            
            <Button outline color="primary" type="submit" onClick={() => saveOrderProfiles(profilesId)} className="p-button-text">
                Guardar Orden
            </Button>
            <Button outline color="danger" type="button" onClick={() => setVisibleOrder(false)} autoFocus>
                Cancelar
            </Button>
        </div>
    );

    return (
        <Dialog visible={visibleOrder} modal header={headerTittle} footer={footerContent} style={{ width: 'auto', height: '80vh', maxWidth: '95vw', overflow: 'auto' }} onHide={() => setVisibleOrder(false)}>
            <label className="text-gray text-sm mt-2" style={{ fontSize: '14px' }}>
                Para ordenar, arrastre a la posición deseada o utilice los botones disponibles. No olvide&nbsp;
                <b style={{ fontSize: '14px' }}>{method === 'create' ? 'Crear' : 'actualizar.'}</b>
            </label>
            <br />

            <Col sm={12}>
           
            <ListOrderingItemProfile
                itemsOrdered={profileOrder}
                onChange={(e) => {
                    setProfileOrder(e.value);     
                }}
            />

          

            </Col>
        </Dialog>
    );
};
